import React, { useState } from 'react'
import closeMenu from '../../Images/closeMenu.png'
import next from '../../Images/next.png'
import './Menu.scss';
import { useLocation } from 'react-router-dom';

export default function Menu({ CitiePhone, navigateTo, setShowMenu, WebSitePages }) {
    const location = useLocation()
    console.log(location);

    const [showMakers, setshowMakers] = useState(false);
    return (
        <div className="Menu">
            <div className="MenuBoxShadow" onClick={() => setShowMenu(false)}></div>
            <div className="MenuList">
                <div className="MenuListTop">
                    <div className="MenuMain">
                        {location.pathname == "/local" || location.pathname == "/" ?
                            <div className="MenuMainBox">
                                <a onClick={() => {
                                    setShowMenu(false)
                                    window.scrollTo(0, 0)
                                }}>HOME PAGE</a>
                            </div>
                            :
                            <div className="MenuMainBox">
                                <a href={`/local${location.search}`}>HOME PAGE</a>
                            </div>
                        }

                        {location.pathname == "/local" || location.pathname == "/" ?
                            <div className="MenuMainBox">
                                <a onClick={() => {
                                    setShowMenu(false)
                                    window.location.hash = 'ourservices'
                                }}>OUR SERVICES</a>
                            </div>
                            :
                            <div className="MenuMainBox" onClick={() => {
                                setshowMakers(true)
                            }}>
                                <h1 >SERVICES</h1>
                                <img src={next} alt=" In LockSmith, | locksmith Repair In LockSmith, | locksmith Services In LockSmith, | locksmith Inspection In LockSmith," />
                            </div>
                        }

                        <div className="MenuMainBox">
                            <a href={`/book${location.search}`}>SCHEDULE ONLINE</a>
                        </div>

                        {location.pathname == "/local" || location.pathname == "/" ?
                            <div className="MenuMainBox">
                                <a onClick={() => {
                                    setShowMenu(false)
                                    window.location.hash = 'reviews'
                                }}>CUSTOMER REVIEWS</a>
                            </div>
                            :
                            <div className="MenuMainBox">
                                <a href={`/reviews/local${location.search}`}>CUSTOMER REVIEWS</a>
                            </div>
                        }

                        {location.pathname == "/local" || location.pathname == "/" ?
                            <div className="MenuMainBox">
                                <a onClick={() => {
                                    setShowMenu(false)
                                    window.location.hash = 'contact'
                                }}>CONTACT US</a>
                            </div>
                            :
                            <div className="MenuMainBox">
                                <a href={`/contact${location.search}`}>CONTACT US</a>
                            </div>
                        }

                        {location.pathname == "/local" || location.pathname == "/" ?
                            null
                            :
                            <div className="MenuMainBox">
                                <a href={`/blog${location.search}`}>BLOG</a>
                            </div>
                        }
                        {location.pathname == "/local" || location.pathname == "/" ?
                            <div className="MenuMainBox">
                                <a onClick={() => {
                                    setShowMenu(false)
                                    window.location.hash = 'about'
                                }}>ABOUT US</a>
                            </div>
                            :
                            null
                        }


                    </div>
                    <div className="MenuFooter">
                        <h5>Copyright © 2024 NoneStop 24/7 Locksmith. All rights reserved.</h5>
                    </div>

                </div>
                <div className="MenuListFooter">
                    <a href={`tel:${CitiePhone}`}>CALL NOW {CitiePhone}</a>
                    <a href={`/book${location.search}`}>SCHEDULE ONLINE</a>
                    <p>
                        Monday - Sunday
                        <br />
                        8:00 a.m. - 8:00 p.m. EST
                    </p>
                </div>

            </div>
        </div>
    )
}
